import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from '@/plugins/Loading';
import './app.scss';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, GraphChart, GaugeChart, PieChart, CustomChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import router from '@/routes/index'; 
import Toast from '@/components/plugins/Toast.vue'
import AIChat from '@/components/AIChat.vue'
import store from './store' // 引入 Vuex
import Vant from 'vant';
import 'vant/lib/index.css';


const ToastConstructor = Vue.extend(Toast)
function showToast(msg) {
  const instance = new ToastConstructor({
    propsData:{msg}
  });
  console.log('instance',instance)
  instance.$mount();
  document.body.appendChild(instance.$el)
  return instance.open()
}
Vue.prototype.$showToast = function(msg) {
  return showToast(msg)
}
Vue.component('AIChat', AIChat)
Vue.config.productionTip = false;
// 启用路由
Vue.use(VueRouter);
// 启用加载插件
Vue.use(Loading);
Vue.use(Vant);
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  GraphChart,
  GaugeChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  CustomChart, // 自定义图表  
  LegendComponent,
  DataZoomComponent
]);
// 启用 echarts
Vue.prototype.$echarts = echarts;



const AppLayout = {
  render(h) {
    return h('div', { class: 'app-container' }, [
      // 可以在这里添加 Header、Sidebar 等全局布局
      h('keep-alive', { props: { exclude: 'Nutrition,Details,AIQuestionnaire' } }, [
        h('router-view', { props: { key: this.$route.path } })
      ]),
      // 全局组件（如底部导航栏、广告条等）
      h('AIChat')
    ])
  }
}
// 启动应用
new Vue({
  // 加载全局路由
  router,
  store, // 挂载到根实例
  // 直接在页面上渲染路由视图
  // render: h => h('router-view')
  render: h => h(AppLayout)
  // render: h =>
  //   h('keep-alive',{ props: { exclude: 'Nutrition,Details' } }, [
  //     h('router-view', {
  //       props: { key: location.pathname } // 可选，强制刷新
  //     })
  //   ])
}).$mount('#app');